'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from '@eliadmin/core/src/components/ui/dialog';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { Heading } from './heading';
import { Paragraph } from './paragraph';
import { Button } from './button';
import { ContactForm } from '../contact/contact-form';
import { useState } from 'react';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

interface PriceOfferDialogProps {
  children: React.ReactNode;
  className?: string;
}

export function PriceOfferDialog({ children, className }: PriceOfferDialogProps) {
  const { t } = useTranslations();
  const [submitted, setSubmitted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (open) {
      setSubmitted(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild className={cn(className)}>
        {children}
      </DialogTrigger>

      <DialogContent
        className={cn(
          'max-h-[90dvh] w-full max-w-[680px] overflow-y-scroll border-none bg-transparent px-5 py-0 shadow-none sm:max-w-[680px]',
          'hide-scroll-bar',
          'ea-price-offer__dialog-content',
        )}
      >
        {!submitted ? (
          <ContactForm
            inDialog={true}
            onSuccess={() => setSubmitted(true)}
            className="p-4 sm:p-6 md:p-8 lg:p-12"
          />
        ) : (
          <div className="flex flex-col items-center gap-6 rounded-[8px] bg-primary-foreground px-4 py-8 sm:px-8 sm:py-10 lg:px-12 lg:py-12">
            <Image
              src="/images/icons/tick-circle.svg"
              alt={t('text643')}
              width={56}
              height={56}
              className="object-contain"
            />
            <Heading title={t('text643')} tag="h2" />
            <Paragraph size="md" color="muted-foreground" className="w-full text-center">
              Žiadosť o cenovú ponuku bola odoslaná. Čo najskôr Vás budeme kontaktovať.
            </Paragraph>
            <DialogClose asChild>
              <Button className="w-full rounded-full sm:w-fit" variant="dark">
                {t('text1855')}
              </Button>
            </DialogClose>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
